import React, { Suspense } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-phone-input-2/lib/style.css";
import "react-quill/dist/quill.snow.css";
import "./scss/main.scss";
import configureStoreProd from "./Pages/config/configureStore.prod";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastContainer } from "react-toastify";
import { lazy } from "react";

const { persistor, store } = configureStoreProd();

function App() {
  const routes = [
    { url: "/login", path: "Login" },
    { url: "/dashboard", path: "Dashboard" },
    { url: "*", path: "NotFoundPage" },
    { url: "/profile", path: "Profile" },
    { url: "/profile/:tab", path: "Settings" },
    { url: "/forgotpassword", path: "Forgotpassword" },
    { url: "/resetpassword", path: "Resetpassword" },
    { url: "/", element: <Navigate to="/login" /> },
    { url: "/forgotpassword/client", path: "ForgotpasswordClient" },
    { url: "/resetpassword/client", path: "ResetpasswordClient" },
    { url: "/otp", path: "Otp" },

    { url: "/user", path: "Users" },
    { url: "/user/edit/:id", path: "Users/AddEdit" },
    { url: "/user/add", path: "Users/AddEdit" },
    { url: "/user/detail/:id", path: "Users/View" },

    { url: "/role", path: "Roles" },
    { url: "/role/edit/:id", path: "Roles/AddEdit" },
    { url: "/role/add", path: "Roles/AddEdit" },
    { url: "/role/detail/:id", path: "Roles/View" },

    { url: "/content", path: "Content" },
    { url: "/content/detail/:slug", path: "Content/View" },
    { url: "/content/add", path: "Content/AddEdit" },
    { url: "/content/edit/:slug", path: "Content/AddEdit" },

    { url: "/blogs", path: "Blogs" },
    { url: "/blogs/detail/:slug", path: "Blogs/View" },
    { url: "/blogs/detail/:id", path: "Blogs/View" },
    { url: "/blogs/add", path: "Blogs/AddEdit" },
    { url: "/blogs/edit/:slug", path: "Blogs/AddEdit" },
    { url: "/blogs/edit/:id", path: "Blogs/AddEdit" },

    { url: "/contactus", path: "Contactus" },
    { url: "/contactus/edit/:id", path: "Contactus/AddEdit" },
    { url: "/contactus/add", path: "Contactus/AddEdit" },
    { url: "/contactus/detail/:id", path: "Contactus/View" },

    { url: "/plans", path: "Plans" },
    { url: "/pricing/:userId", path: "Plans/Pricing" },
    { url: "/plans/edit/:id", path: "Plans/AddEdit" },
    { url: "/plans/add", path: "Plans/AddEdit" },
    { url: "/plans/detail/:id", path: "Plans/View" },

    { url: "/business", path: "BusinessUsers" },
    { url: "/business/edit/:id", path: "BusinessUsers/AddEdit" },
    { url: "/business/add", path: "BusinessUsers/AddEdit" },
    { url: "/business/detail/:id", path: "BusinessUsers/View" },

    { url: "/subscriptions", path: "PlanTransaction" },

    { url: "/recommendation", path: "Recommendation" },
    { url: "/recommendation/detail/:id?", path: "Recommendation/View" },

    { url: "/email/template", path: "EmailTempletsall" },
    { url: "/email/template/copy/:id?", path: "EmailTempletsall/Duplicate" },
    { url: "/email/template/add", path: "EmailTempletsall/AddEdit" },
    { url: "/email/template/edit/:id?", path: "EmailTempletsall/AddEdit" },
    { url: "/email/template/detail/:id?", path: "EmailTempletsall/View" },

    { url: "/onboarding", path: "Onboarding" },
    { url: "/onboarding/edit/:id?", path: "Onboarding/AddEdit" },
    { url: "/onboarding/detail/:id?", path: "Onboarding/View" },
    // { url: "/onboarding/add", path: "Onboarding/AddEdit" },

    // { url: "/testimonials", path: "Testimonials" },
    // { url: "/testimonials/edit/:id?", path: "Testimonials/AddEdit" },
    // { url: "/testimonials/detail/:id?", path: "Testimonials/View" },
    // { url: "/testimonials/add", path: "Testimonials/AddEdit" },

    { url: "/storage", path: "StorageManagement" },
    { url: "/storage/edit/:id?", path: "StorageManagement/AddEdit" },
    { url: "/storage/detail/:id?", path: "StorageManagement/View" },
    { url: "/storage/add", path: "StorageManagement/AddEdit" },

    { url: "/case/study", path: "CaseStudy" },
    { url: "/case/study/edit/:id?", path: "CaseStudy/AddEdit" },
    { url: "/case/study/detail/:id?", path: "CaseStudy/View" },
    { url: "/case/study/add", path: "CaseStudy/AddEdit" },

    { url: "/certificates", path: "Certificates" },
    { url: "/certificates/copy/:id?", path: "Certificates/Duplicate" },
    { url: "/certificates/add", path: "Certificates/AddEdit" },
    { url: "/certificates/edit/:id?", path: "Certificates/AddEdit" },
    { url: "/certificates/detail/:id?", path: "Certificates/View" },

    // { url: "/contractor", path: "Contractors" },
    // { url: "/contractor/edit/:id", path: "Contractors/AddEdit" },
    // { url: "/contractor/add", path: "Contractors/AddEdit" },
    // { url: "/contractor/detail/:id", path: "Contractors/View" },
    // { url: "/contractor/request/:id", path: "Contractors/Request" },

    // { url: "/skill", path: "Skills" },
    // { url: "/skill/edit/:id", path: "Skills/AddEdit" },
    // { url: "/skill/add", path: "Skills/AddEdit" },
    // { url: "/skill/detail/:id", path: "Skills/View" },

    // { url: "/invoice", path: "Invoice" },
    // { url: "/invoice/edit/:id", path: "Invoice/AddEdit" },
    // { url: "/invoice/add", path: "Invoice/AddEdit" },
    // { url: "/invoice/detail/:id", path: "Invoice/View" },

    // { url: "/job", path: "Jobs" },
    // { url: "/job/edit/:id", path: "Jobs/Edit" },
    // { url: "/job/add", path: "Jobs/AddEdit" },
    // { url: "/job/detail/:id?", path: "Jobs/View" },

    // { url: "/supplier", path: "Suppliers" },
    // { url: "/supplier/edit/:id", path: "Suppliers/AddEdit" },
    // { url: "/supplier/add", path: "Suppliers/AddEdit" },
    // { url: "/supplier/detail/:id", path: "Suppliers/View" },

    // { url: "/tools-supplier", path: "SuppliersTools" },
    // { url: "/tools-supplier/edit/:id", path: "SuppliersTools/AddEdit" },
    // { url: "/tools-supplier/add", path: "SuppliersTools/AddEdit" },
    // { url: "/tools-supplier/detail/:id", path: "SuppliersTools/View" },

    // { url: "/material", path: "Materials" },
    // { url: "/material/edit/:id", path: "Materials/AddEdit" },
    // { url: "/material/add", path: "Materials/AddEdit" },
    // { url: "/material/detail/:id", path: "Materials/View" },

    // { url: "/project", path: "Projects" },
    // { url: "/project/edit/:id", path: "Projects/AddEdit" },
    // { url: "/project/add", path: "Projects/AddEdit" },
    // { url: "/project/detail/:id", path: "Projects/View" },

    // { url: "/category", path: "Category" },
    // { url: "/category/edit/:id", path: "Category/AddEdit" },
    // { url: "/category/add", path: "Category/AddEdit" },
    // { url: "/category/detail/:id", path: "Category/View" },

    // { url: "/customers", path: "Customers" },
    // { url: "/customers/edit/:id", path: "Customers/AddEdit" },
    // { url: "/customers/add", path: "Customers/AddEdit" },
    // { url: "/customers/detail/:id", path: "Customers/View" },

    // { url: "/cis", path: "CisTax" },
    // { url: "/cis/edit/:id", path: "CisTax/AddEdit" },
    // { url: "/cis/add", path: "CisTax/AddEdit" },
    // { url: "/cis/detail/:id", path: "CisTax/View" },

    // { url: "/travel", path: "Travelrate" },
    // { url: "/travel/edit/:id", path: "Travelrate/AddEdit" },
    // { url: "/travel/add", path: "Travelrate/AddEdit" },
    // { url: "/travel/detail/:id", path: "Travelrate/View" },

    // { url: "/payable", path: "Payable" },
    // { url: "/payable/edit/:id", path: "Payable/AddEdit" },
    // { url: "/payable/add", path: "Payable/AddEdit" },
    // { url: "/payable/detail/:id/:jobid?", path: "Payable/View" },

    // { url: "/vat", path: "Vat" },
    // { url: "/vat/edit/:id", path: "Vat/AddEdit" },
    // { url: "/vat/add", path: "Vat/AddEdit" },
    // { url: "/vat/detail/:id", path: "Vat/View" },

    // { url: "/transaction", path: "Transaction" },

    // { url: "/generate/invoice/:id", path: "InvoiceGenerate" },
    // { url: "/pay/:id?", path: "Paynow" },
    // { url: "/schedule", path: "Schedule/AddEdit" },

    // { url: "/company", path: "Company" },
    // { url: "/custom/report", path: "Calendar/CustomScheduleCalendar" },

    // { url: "/payslip/:id?", path: "Paysliplist" },

    // { url: "/complete/job/:id?", path: "CompoleteJob" },

    // { url: "/create/payslip/:id/:sdate/:edate?", path: "Payslippage" },

    // { url: "/create/payslip/manual", path: "Payslipnonworked" },

    // { url: "/reminder", path: "Reminder" },
    // { url: "/reminder/edit/:id", path: "Reminder/AddEdit" },
    // { url: "/reminder/add", path: "Reminder/AddEdit" },
    // { url: "/reminder/detail/:id", path: "Reminder/View" },

    // { url: "/accountant", path: "Accountant" },
    // { url: "/accountant/edit/:id", path: "Accountant/AddEdit" },
    // { url: "/accountant/add", path: "Accountant/AddEdit" },
    // { url: "/accountant/detail/:id", path: "Accountant/View" },

    // { url: "/edit/invoice/:id", path: "Editsaveinvoice" },

    // { url: "/report/detail/:id", path: "SavedReports/View" },

    // { url: "/features", path: "Features" },
    // { url: "/features/edit/:id", path: "Features/AddEdit" },
    // { url: "/features/add", path: "Features/AddEdit" },
    // { url: "/features/detail/:id", path: "Features/View" },

    // { url: "/orders", path: "OrderMaterials" },
    // { url: "/orders/add", path: "OrderMaterials/AddEdit" },
    // { url: "/orders/edit/:id?", path: "OrderMaterials/AddEdit" },
    // { url: "/orders/detail/:id?", path: "OrderMaterials/View" },

    // { url: "/tools", path: "Tools" },
    // { url: "/tools/add", path: "Tools/AddEdit" },
    // { url: "/tools/edit/:id?", path: "Tools/AddEdit" },
    // { url: "/tools/detail/:id?", path: "Tools/View" },

    // { url: "/login/hrs/:id?", path: "Loginhrs" },
    // { url: "/saved-report/preview", path: "ReportPreview" },
    // { url: "/saved-report/preview/:id?", path: "ReportPreview" },

    // { url: "/registering/costs/:id?", path: "InsertMaterial" },

    // { url: "/service", path: "OtherServices" },
    // { url: "/service/edit/:id", path: "OtherServices/AddEdit" },
    // { url: "/service/add", path: "OtherServices/AddEdit" },
    // { url: "/service/detail/:id", path: "OtherServices/View" },

    // { url: "/expense/log", path: "ExpenseLog" },
    // { url: "/expense/log/edit/:id", path: "ExpenseLog/Edit" },
    // { url: "/expense/log/add", path: "ExpenseLog/AddEdit" },
    // { url: "/expense/log/detail/:id", path: "ExpenseLog/View" },

    // { url: "/statistics", path: "CompanyCosts" },

    // { url: "/spending", path: "CompanySpending" },
    // { url: "/spending/edit/:id", path: "CompanySpending/AddEdit" },
    // { url: "/spending/add", path: "CompanySpending/AddEdit" },
    // { url: "/spending/detail/:id", path: "CompanySpending/View" },

    // { url: "/interim/invoice/:id", path: "InterimInvoice" },

    // { url: "/working/week", path: "WorkingWeek/WorkingWeek" },

    // { url: "/estimate", path: "Estimating" },
    // { url: "/estimate/add", path: "Estimating/AddEdit" },
    // { url: "/estimate/edit/:id?", path: "Estimating/AddEdit" },
    // { url: "/estimate/duplicate/:id?", path: "Estimating/Duplicate" },
    // { url: "/estimate/detail/:id?", path: "Estimating/View" },
    // { url: "/estimate/report/:id?", path: "Estimating/Report" },

    // { url: "/job/configuration", path: "JobConfiguration" },
    // { url: "/job/configuration/add", path: "JobConfiguration/AddEdit" },
    // { url: "/job/configuration/edit/:id?", path: "JobConfiguration/AddEdit" },
    // { url: "/job/configuration/detail/:id?", path: "JobConfiguration/View" },

    // { url: "/cost/register", path: "ResiterCost" },
    // { url: "/cost/register/add", path: "ResiterCost/AddEdit" },
    // { url: "/cost/register/edit/:id?", path: "ResiterCost/AddEdit" },
    // { url: "/cost/register/detail/:id?", path: "ResiterCost/View" },

    // { url: "/commaninv/:id/:type", path: "InvoiceForAll" },
    // { url: "/inv/reports", path: "InvoiceReport" },

    // { url: "/review", path: "FeedBacks" },
    // { url: "/review/detail/:id?", path: "FeedBacks/View" },

    // { url: "/rewards", path: "Rewards" },
    // { url: "/rewards/detail/:id?", path: "Rewards/View" },

    // { url: "/settings", path: "RewardSetting" },
    // { url: "/settings/add", path: "RewardSetting/AddEdit" },
    // { url: "/settings/edit/:id?", path: "RewardSetting/AddEdit" },
    // { url: "/settings/detail/:id?", path: "RewardSetting/View" },

    // { url: "/leaves", path: "Leaves" },
    // { url: "/leaves/add", path: "Leaves/AddEdit" },
    // { url: "/leaves/edit/:id?", path: "Leaves/AddEdit" },
    // { url: "/leaves/detail/:id?", path: "Leaves/View" },

    // { url: "/estimate/inv/:id", path: "Estimating/EstimateInvoice" },
  ];

  sessionStorage.clear();

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={"loading ..."} persistor={persistor}>
          <Suspense
            fallback={
              <div id="loader" className="loaderDiv">
                <div>
                  <img
                    src="/assets/img/loader.gif"
                    alt="logo"
                    className="loaderlogo"
                  />
                </div>
              </div>
            }
          >
            <Router>
              <Routes>
                {routes.map((itm) => {
                  const Element = lazy(() => import(`./Pages/${itm.path}`));
                  return (
                    <Route
                      path={itm.url}
                      element={itm.path ? <Element /> : itm.element}
                    />
                  );
                })}
              </Routes>
            </Router>
          </Suspense>
        </PersistGate>
      </Provider>
      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
        </div>
      </div>
      <ToastContainer position="top-right" />
    </>
  );
}

export default App;
